import api from "./api";

export const callGetActivePayMethods = async () => {
  try {
    return await api.get(`/payment/web/pay_method`);
  } catch (error) {
    console.log("Error callGetActivePayMethods");
  }
};

export const callGetDashboardPayMethods = async (page, offset) => {
  try {
    return await api.get(
      `/payment/dashboard/pay_method?page=${page}&offset=${offset}`
    );
  } catch (error) {
    console.log("Error callGetDashboardPayMethods");
  }
};

export const callCreateDashboardPayMethods = async (data) => {
  try {
    return await api.post("/payment/dashboard/pay_method/create", data);
  } catch (error) {
    console.log("Error callCreateDashboardPayMethods");
  }
};

export const callUpdateDashboardPayMethods = async (data) => {
  try {
    return await api.put(
      `/payment/dashboard/pay_method/update/${data.payMethodId}`,
      data
    );
  } catch (error) {
    console.log("Error callUpdateDashboardPayMethods");
  }
};
